import { Component, inject, Input, OnInit } from '@angular/core';
import { SmallTuileComponent } from '../../../../../../../../components/ecosystems/small-tuile/small-tuile.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import { TuileButtonProps } from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import { P0003601ProgrammeFiltrationAuto } from '../../../Enum/P0003601ProgrammeFiltrationAuto';

@Component({
  selector: 'app-p0003601-card-filtration-statut',
  templateUrl: './p0003601-card-filtration-statut.component.html',
  styleUrls: ['./p0003601-card-filtration-statut.component.scss'],
  imports: [SmallTuileComponent, TranslatePipe],
})
export class P0003601CardFiltrationStatutComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  getStatus() {
    return this.actionStack!.getValue('fvsSVitesseFiltration') == 0
      ? 'P0003601.card.status.stop'
      : this.actionStack!.getValue('fvsSVitesseFiltration') == 1
        ? 'P0003601.card.status.v1'
        : this.actionStack!.getValue('fvsSVitesseFiltration') == 2
          ? 'P0003601.card.status.v2'
          : 'P0003601.card.status.max';
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  getButtons(): TuileButtonProps[] {
    const vitesseManuelle =
      this.actionStack!.getValue('fvsCVitesseManuelle') ?? 0;

    let res = 'fa-kit fa-picto-vs-v1';

    if (vitesseManuelle === 1) {
      res = 'fa-kit fa-vs-v1';
    } else if (vitesseManuelle === 2) {
      res = 'fa-kit fa-vs-v2';
    } else if (vitesseManuelle === 3) {
      res = 'fa-kit fa-vs-max';
    }

    return [
      {
        title: 'P0003601.card.state.filtration.status.off',
        icon: 'fa-kit fa-picto-off',
        color: 'color-red',
        status: 'inactive',
      },
      {
        title: 'P0003601.card.state.filtration.status.onManuel',
        icon: res,
        color: 'color-green',
        status: 'active',
      },
      {
        title: 'P0003601.card.state.filtration.status.auto',
        icon: 'fa-kit fa-picto-programme',
        color: 'color-orange',
        status: 'active',
      },
    ];
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.FILTRATION_VS,
      FunctionOnglet.CONTROL,
      this.translateService.instant('dashboard.filtrationvs'),
    );
  }

  protected readonly P0003601ProgrammeFiltrationAuto =
    P0003601ProgrammeFiltrationAuto;
}
